import saveAs from 'file-saver'

import { post, get } from '@/util/auth'

import type { OnboardingPayload } from './types'

const onboardingResources = {
  authorizeFileDownload: async () => {
    const response = await get<{ body: string; filename: string }>(
      'form/:code/porting/authorization'
    )
    saveAs(atob(response.body), response.filename)
    return { filename: response.filename }
  },

  // Mutations
  post: (payload: OnboardingPayload) => post('form/:code/porting', payload),
  uploadAuthorization: async ({ file, type }: { file: File; type: string }) => {
    const base64EncodedFile = await getBase64(file)
    const parsedFile = transformFileForWS({ file, base64EncodedFile, type })

    const response = await post('form/:code/porting/authorization', parsedFile)

    return response
  },
}

export default onboardingResources

const getBase64 = (file: File) =>
  new Promise<string | ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (reader.result) resolve(reader.result)
    }
    reader.onerror = error => reject(error)
  })

const transformFileForWS = ({
  file,
  base64EncodedFile,
  type,
}: {
  file: File
  base64EncodedFile: string | ArrayBuffer
  type: string
}) => ({
  type,
  filename: file.name,
  extension: file.name.split('.').pop()?.toUpperCase(),
  body: base64EncodedFile,
})
